/*global chrome*/
import React from "react";
import $ from "jquery";
import MapSearch from "./MapSearch";

export default class Shortcuts extends React.Component {

    constructor(props) {
        super(props);
        this.createTab = this.createTab.bind(this)
        this.state = {
            searchText: ""
        }

    }

    createTab(url) {
        chrome.tabs.create({ url: url })
    }

    search() {
        if (this.state.searchText !== "") {
            window.open(`https://earthview360.org/links/search.php?${encodeURIComponent(this.state.searchText)}`, "_blank")
        }
    }

    render() {
        return (
            <div className="shortcuts-modal" id="shortcuts-modal">
                <div className="shortcuts-main-menu">
                    <div className="wrapper1">
                        <div className="text-center mb-2 bold">Search Earth Maps</div>
                        <hr style={{ width: '75%', margin: '0px auto 15px auto' }} />
                        <div className="search-input2">
                            <form id="topbar-form1">
                                <MapSearch />
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}